// extracted by mini-css-extract-plugin
module.exports = {"table__actions":"UsersTable_table__actions__gudM0"};